var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{attrs:{"variant":"info","size":"md","disabled":_vm.disabled},on:{"click":_vm.submit}},[_c('i',{staticClass:"fa fa-check"}),_vm._v(" "+_vm._s(_vm.text)+"\n")])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e9f9f1aa","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components-base/components-custom/submit-button/submit-button.vue
// module id = null
// module chunks = 